import { render, staticRenderFns } from "./DataTableAG.vue?vue&type=template&id=b475c97a&"
import script from "./DataTableAG.vue?vue&type=script&lang=js&"
export * from "./DataTableAG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports